import React, { useState, useEffect } from "react";
import { useSiteContext } from "@americanbible/uikit";
import PropTypes from "prop-types";
import scrollIntoView from "scroll-into-view-if-needed";
import OutsideClickHandler from "react-outside-click-handler";

import { DropdownTrigger, DropdownContent } from "../../../AppBar/Dropdown";
import { withBible } from "../../../Bible/BibleContainer";
import { withChapter } from "../../ChapterContainer";
import BookChapterReference from "./BookChapterReference";
import { BookList } from "./styles";
import { BookChapterList } from "./BookChapterList";
import { AllBookChapterList } from "./AllBookChapterList";
import { getMaxMenuHeight } from "../utils";

const BookChapterDropdown = ({ bible, chapter, isOpen, toggle }) => {
  const [selectedBookId, setSelectedBookId] = useState();
  const { includeAllBibles } = useSiteContext();

  useEffect(() => {
    const bookId = chapter.currentChapterId.split(".")[0];
    const target = document.getElementById(bookId);
    const boundary = document.getElementById("bible-chapter-dropdown-content");
    if (isOpen && bookId && target && boundary) {
      scrollIntoView(target, {
        scrollMode: "if-needed",
        boundary
      });
    }
  }, [isOpen, chapter.currentChapterId]);

  const currentBible = bible.getCurrentBible();
  const currentChapter = chapter.getCurrentChapter();
  if (!currentBible || !currentBible.books) return null;

  const handleBookClick = bookId => {
    setSelectedBookId(bookId === selectedBookId ? null : bookId);
  };

  const handleChapterClick = newChapter => {
    chapter.onChapterSelect(newChapter);
    toggle(true);
  };

  const handleToggle = () => {
    setSelectedBookId(chapter.getCurrentChapter().bookId);
    toggle();
  };

  const bookId = currentChapter ? currentChapter.bookId : null;

  return (
    <div>
      <DropdownTrigger arrow toggle={() => handleToggle()} isOpen={isOpen}>
        <BookChapterReference />
      </DropdownTrigger>
      <OutsideClickHandler
        onOutsideClick={() => {
          if (isOpen) handleToggle();
        }}
      >
        {includeAllBibles ? (
          isOpen ? (
            <AllBookChapterList
              books={currentBible.books}
              chapter={chapter}
              handleChapterClick={handleChapterClick}
            />
          ) : (
            <></>
          )
        ) : (
          <DropdownContent
            id="bible-chapter-dropdown-content"
            isOpen={isOpen}
            style={{ height: getMaxMenuHeight() }}
          >
            <BookList>
              {currentBible.books.map(book => (
                <BookChapterList
                  key={book.id}
                  bookId={bookId}
                  selectedBookId={selectedBookId}
                  handleBookClick={handleBookClick}
                  handleChapterClick={handleChapterClick}
                  book={book}
                  chapter={chapter}
                />
              ))}
            </BookList>
          </DropdownContent>
        )}
      </OutsideClickHandler>
    </div>
  );
};

BookChapterDropdown.propTypes = {
  bible: PropTypes.shape({
    getCurrentBible: PropTypes.func.isRequired
  }).isRequired,
  chapter: PropTypes.shape({
    onChapterSelect: PropTypes.func.isRequired,
    getCurrentChapter: PropTypes.func.isRequired,
    currentChapterId: PropTypes.string
  }).isRequired
};

export const UnwrappedBookChapterDropdown = BookChapterDropdown;
export default withChapter(withBible(BookChapterDropdown));
